import React, { Component } from 'react';
import { Feed, Projects, Seo } from 'components';
import { Hello } from 'components/HelloMain';
import { About } from 'components/AboutMain';
import { Showreel } from 'components/Showreel';
import Logos from 'components/_dark/DarkShowreel/components/Logos';
import { classname } from 'utils';
import { graphql } from 'gatsby';

class Main extends Component {
  render() {
    let list = this.props.data.site.siteMetadata.main;
    // Используем класс dark-showreel для совместимости со стилями компонента Logos
    const logosCl = classname('dark-showreel');

    return (
      <>
        <Seo
          title="Диджитал-агентство Nimax"
          description="Стратегия и диджитал. Помогаем стартовать и меняться. Объединяем отраслевой опыт клиента и нашу диджитал-экспертизу. Прививаем компаниям новые подходы к работе и диджитал-технологии, развиваем рынок и специалистов."
        />
        {/* <Hello video={['/hello/header-big.h264.mp4']} /> */}
        <Hello video={['/hello/cross.mp4']} poster={'/hello/video-poster.png'} />
        <Logos
          logos={[
            '/pages/brands/logos/logo_new_0_0.svg',
            '/pages/brands/logos/logo_1.svg',
            '/pages/brands/logos/logo_2.svg',
            '/pages/brands/logos/logo_3.svg',
            '/pages/brands/logos/logo_4.svg',
            '/pages/brands/logos/logo_5.svg',
            '/pages/brands/logos/logo_6.svg',
            '/pages/brands/logos/logo_7.svg',
            '/pages/brands/logos/logo_9.svg',
            '/pages/brands/logos/logo_10.svg',
            '/pages/brands/logos/logo_11.svg',
            '/pages/brands/logos/logo_12.svg',
            '/pages/brands/logos/logo_new_13_0.svg'
          ]}
          cl={logosCl}
        />
        {/* <Showreel /> */}
        <Projects category="main" />
        {/* <About /> */}
      </>
    );
  }
}

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        main
      }
    }
  }
`;

export default Main;
